<template>
  <div class="container-left" @keypress="onEnter" >
    <AmSteps
      v-if="getEnableAddress !== null"
      ref="steps"
      v-model="getCurrentStep"
      class="steps"
      :steps="steps"
      :current-step="getCurrentStep"
      hide-previous
      hide-next
    >
      <AmCard
        class="container-left__card"
        :lean="$mq === 'mobile'"
      >
        <template>
          <router-view ref="currentStep" />
        </template>
        <template
          v-if="showFooterButtons"
          #footer
        >
          <div class="container-left__buttons">
            <!-- Botao continuar -->
            <AmButton
              v-if="showContinueButton"
              ref="defaultCheckoutButton"
              data-test="next_step"
              :disabled="loadingGlobal || disabledStateBtn"
              :label="$t('steps.nextStep')"
              :class="['next', theme.color]"
              size="xl"
              full-width
              @click="actionsPostSteps()"
            >
              <template
                v-if="loadingGlobal"
                #content
              >
                <AmLoading
                  class="loading--white"
                  :AmLoaderSize="24"
                />
              </template>
            </AmButton>
            <!-- Botao pagar Apple Pay-->
            <ApplePayButton
              v-if="showApplePayButton"
              :disabled="loadingGlobal || disabledStateBtn"
              @click.native="actionsPostSteps()"
            />
            <!-- Botao pagar: outros -->
            <AmButton
              v-else-if="showPaymentButton"
              data-test="payment"
              :class="['next', theme.color]"
              :label="getNextLabel.label"
              size="xl"
              full-width
              :icon="getNextLabel.icon"
              :disabled="loadingGlobal || disabledStateBtn"
              @click="actionsPostSteps()"
            >
              <template
                v-if="loadingGlobal"
                #content
              >
                <AmLoading
                  class="loading--white"
                  :AmLoaderSize="24"
                />
              </template>
            </AmButton>
            <!-- Botao voltar -->
            <AmButton
              v-show="handleReturnButtonVisible"
              :disabled="loadingGlobal"
              :label="returnStepLabel"
              :fullWidth="true"
              data-test="return_payment"
              type="text"
              color="blue"
              size="xl"
              @click="returnStep()"
            />
          </div>
        </template>
      </AmCard>
    </AmSteps>

    <AmFooter />
  </div>
</template>

<script>
import replaceSpecialCharactersMixin from '@/components/mixins/replaceSpecialCharactersMixin'
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'
import ApplePayButton from '@/components/atoms/ApplePayButton.vue'
import ApplePayConfigs from '@/utils/ApplePay/configs'
import AmSteps from '@/components/molecules/AmSteps.vue'
import AmFooter from '../AmFooter/AmFooter.vue'

export default {
  name: 'ContainerLeftNEW',
  components: {
    AmSteps,
    ApplePayButton,
    AmFooter,
  },
  mixins: [themeMixin, replaceSpecialCharactersMixin, currencyFilterMixin],
  computed: {
    ...mapState('Checkout', {
      cartStatus: (state) => state.cart,
      loadingGlobal: (state) => state.cartLoading,
      getThemeColor: (state) => state.theme.color,
      disabledStateBtn: (state) => state.disabledStateBtn,
    }),
    ...mapGetters('Checkout', ['getCurrentStep', 'getPaymentType']),
    ...mapGetters('Cart', ['isInfoProduto', 'getEnableAddress']),
    showApplePayButton() {
      return this.isUsingApplePay && this.getCurrentStep >= 4 && this.getCurrentStep !== 10
    },
    showPaymentButton() {
      return this.getCurrentStep >= 4 && this.getCurrentStep !== 10
    },
    showFooterButtons() {
      return this.getCurrentStep >= 0
    },
    showContinueButton() {
      return this.getCurrentStep < 4 && this.getCurrentStep !== 10
    },
    handleReturnButtonVisible() {
      return this.getCurrentStep !== 0 && this.getCurrentStep !== 10
    },
    isUsingApplePay() {
      return this.getPaymentType === ApplePayConfigs.key
    },
    getNextLabel() {
      const icon = {
        name: 'local_mall',
        position: 'left',
        type: 'material',
        size: 'xl',
      }

      const paymentButtonIcon = {
        card: 'local_mall',
        billet: 'view_week',
        pix: 'pix',
      }

      const labelButtonPayment = {
        card: this.$t('steps.actionsLabels[0]'),
        billet: this.$t('steps.actionsLabels[1]'),
        pix: this.$t('steps.actionsLabels[2]'),
      }

      icon.name = paymentButtonIcon[this.getPaymentType]

      return {
        icon,
        label: labelButtonPayment[this.getPaymentType],
      }
    },
    returnStepLabel() {
      const stepsLabelWithAdress = {
        0: this.$t('return'),
        1: this.$t('steps.returnIndetifyStep'),
        2: this.$t('steps.returnAddressStep'),
        3: this.$t('steps.returnAddressStep'),
        4: this.$t('return'),
      }
      const stepsLabelInfoProducto = {
        0: this.$t('return'),
        3: this.$t('steps.returnIndetifyStep'),
        4: this.$t('return'),
      }
      const stepsLabel = this.isInfoProduto ? stepsLabelInfoProducto : stepsLabelWithAdress
      return stepsLabel[this.getCurrentStep] ? stepsLabel[this.getCurrentStep] : stepsLabel[4]
    },
    steps() {
      const stepsWithAddress = [
        {
          title: this.$t('steps.titles[0]'),
        },
        {
          title: this.$t('steps.titles[1]'),
        },
        {
          title: this.$t('steps.titles[2]'),
        },
      ]
      const stepsInfoProduto = [
        {
          title: this.$t('steps.titles[0]'),
        },
        {
          title: this.$t('steps.titles[2]'),
        },
      ]

      return this.getEnableAddress !== null && this.isInfoProduto
        ? stepsInfoProduto
        : stepsWithAddress
    },
  },
  watch: {
    getThemeColor: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.hiddenButtonInProgress = true
        } else {
          this.hiddenButtonInProgress = false
        }
      },
    },
    $route: {
      handler(route) {
        this.setEnableAndDisableAddRemoveQuantityBundle(route.name)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions('Checkout', [
      'identify',
      'shipping',
      'fetchCep',
      'paymentBillet',
      'paymentCreditCard',
      'paymentPix',
      'states',
      'createOrder',
      'fetchCart',
    ]),
    ...mapMutations('Checkout', [
      'SET_CURRENT_STEP',
      'SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE',
      'SET_STATUS_CART_LOADING',
    ]),
    getSteps() {
      const stepsWithAddress = [
        {
          title: this.$t('steps.titles[0]'),
        },
        {
          title: this.$t('steps.titles[1]'),
        },
        {
          title: this.$t('steps.titles[2]'),
        },
      ]
      const stepsInfoProduto = [
        {
          title: this.$t('steps.titles[0]'),
        },
        {
          title: this.$t('steps.titles[2]'),
        },
      ]
      this.steps =
        this.getEnableAddress !== null && this.isInfoProduto ? stepsInfoProduto : stepsWithAddress
    },
    nextStep() {
      this.$refs.currentStep.nextStep()
    },
    returnStep() {
      this.$refs.currentStep.previousStep()
    },
    setEnableAndDisableAddRemoveQuantityBundle(name) {
      const enableAndDisableAddRemoveQuantityBundle =
        name === 'new.stepPaymentSuccess' ||
        name === 'new.stepPaymentPixSuccess' ||
        name === 'new.stepPaymentCardLoading' ||
        name === 'new.stepPaymentBilletSuccess' ||
        name === 'new.stepPaymentError' ||
        name === 'new.stepPaymentApplePaySuccess'

      this.SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE(enableAndDisableAddRemoveQuantityBundle)
    },
    actionsPostSteps() {
      this.nextStep()
    },
    onEnter(e) {
      if (e.keyCode === 13) {
        this.nextStep()
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.container-left {
  width: 70%;
  min-height: 100%;
  overflow: auto;
  background: $light-20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @include mobile {
    justify-content: flex-start;
    width: 100%;
    background: transparent;
    max-height: 100vh;
  }

  @include tablet {
    width: 100%;
  }

  &__card {
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: space-between;
    flex: 1;
    min-height: 457px;
    background: $white;
    padding: 32px;
    height: 100%;

    @include mobile {
      width: 100%;
      padding: 0;
    }

    @include tablet {
      height: unset;
      width: 100%;
    }

    @include desktop {
      width: 100%;
      margin: 0;
    }

    .data {
      width: 100%;
    }
  }

  &__buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .steps {
    width: 60%;
    margin-top: 80px;

    @include mobile {
      width: 100%;
      padding: 0 16px;
      margin-top: 70px;
    }

    &__change-payment,
    &__return-step {
      margin: 15px 0 0 0;
      text-align: center;
      width: 100%;
      .steps__change-payment__return,
      .steps__return-step__return {
        cursor: pointer;
      }
    }

    &__return-step {
      margin: 17px 0 22px 0;
    }

    &__payment {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }

    .next {
      &:disabled {
        border-color: $sys-gray-mid !important;
        background-color: $sys-gray-mid !important;

        ::v-deep {
          &.button-content .icon .am-icon .am-icon-material {
            color: $white !important;
            font-size: 20px;
          }
        }
      }
    }
  }

  .link {
    text-decoration: none;
  }
  .AmSkeleton {
    margin: 28px;

    ::v-deep {
      .b-skeleton {
        background-color: $light-80 !important;
      }
      .b-skeleton-animate-wave::after {
        background: linear-gradient(90deg, transparent, $white, transparent);
      }
    }
  }
}

.payment__button {
  margin-top: 203px;
}

::v-deep .am-card {
  overflow: visible;

  @include mobile {
    padding: 0;
  }
}
</style>
